module.exports = __webpack_public_path__ + "media/images/top/for-beginner-d32342ca9cbf894e71533705d2d4acaa.jpg";